import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteCustomerAlertDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const cancelRef = useRef();
  const { t } = useTranslation();
  return (
    <AlertDialog
      isOpen={isOpen}
      // @ts-ignore
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t("screens.client.deleteCustomer")}
          </AlertDialogHeader>

          <AlertDialogBody>
            {t("screens.client.deleteCustomerMessage")}
          </AlertDialogBody>

          <AlertDialogFooter>
            {/* @ts-ignore */}
            <Button ref={cancelRef} onClick={onClose}>
              {t("common.cancel")}
            </Button>
            <Button colorScheme="red" onClick={onConfirm} ml={3}>
              {t("screens.client.deleteCustomer")}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
